import isCurrentMq from '@module/isCurrentMq';
import getHeaderH from '@module/getHeaderH';
import fixBody from '@module/fixBody';

/**
 * グロナビ開閉
 * 
 * @param {boolean} fullScreen - 全画面表示かどうか
    * trueならヘッダーを覆うように全画面にグロナビを表示（フェードイン）
        *・.js_gnavと.js_menubarのactiveクラスをトグル
    * falseならヘッダーの下にグロナビを表示（アコーディオン）
        *・js_menubarをクリックすると.js_gnavにactiveクラスを追加
        *・js_closeをクリックすると.js_gnavからactiveクラスを削除

 * @param {number} transition - 開閉時のアニメーション時間（ミリ秒）
*/
const toggleGnav = (fullScreen = false, transition = 300) => {
    const trigger = document.querySelector('.js_menubar'); //メニューバー
    const target = document.querySelector('.js_header'); //グロナビ
    const closeTrigger = target.querySelector('.js_close'); //閉じるボタン
    if (!trigger || !target) return;

    /**
     * カスタムプロパティをグロナビに設定
    */
    const setPropertyToTarget = () => {
        // 上からの位置
        const headerH = !fullScreen ? getHeaderH() : 0;
        target.style.setProperty('--top', `${headerH}px`);

        // 展開後の高さ
        if (!fullScreen) {
            const endHeight = `${window.innerHeight - headerH}px`;
            target.style.setProperty('--end-height', endHeight);
        }

        // アニメーション時間
        target.style.setProperty('--transition', `${transition}ms`);
    }

    setPropertyToTarget(); //初期実行
    window.addEventListener('resize', setPropertyToTarget); //リサイズ時実行
    
    /**
     * 開閉
    */
    // 開く
    const open = () => {
        target.classList.add('is_show');
        fixBody('open', transition);
    }

    // 閉じる
    const close = () => {
        target.classList.remove('is_show');
        trigger.classList.remove('is_active');
        fixBody('close', transition);
    }

    // トグル
    const toggle = () => {
        trigger.classList.toggle('is_active');
        if (target.classList.contains('is_show')) {
            close();
        } else {
            open();
        }
    }
    
    trigger.addEventListener('click', toggle);
    if (closeTrigger) {
        closeTrigger.addEventListener('click', close);
    }

    /**
     * グロナビ内のページ内リンクをクリックしたらグロナビを閉じる
     */
    const anchorLink = () => {
        // グロナビ内のhref="#"のaタグを取得
        const anchorList = target.querySelectorAll('a[href*="#"]');
        if (!anchorList.length) return;

        // クリックイベントを追加
        anchorList.forEach(anchor => {
            anchor.addEventListener('click', () => {
                // デスクトップサイズの場合はグロナビを閉じない（グロナビが常時表示のため）
                const currentMq = isCurrentMq();
                if (currentMq === 'md-header' || currentMq === 'md' || currentMq === 'lg' || currentMq === 'xl') return;
                close(); //グロナビを閉じる
            });
        });
    }
    anchorLink();

    // 画面幅のブレークポイントが変わった時だけ閉じる
    let lastMq = isCurrentMq();
    window.addEventListener('resize', () => {
        const mq = isCurrentMq();
        if (
            mq !== lastMq &&
            (mq === 'md-header' || mq === 'md' || mq === 'lg' || mq === 'xl')
        ) {
            close();
        }
        lastMq = mq;
    });
}

export default toggleGnav